import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AllocationCard from "../../../components/UI/Cards/AllocationCard/AllocationCard";
import { getAddedParkerToAllocationModel } from "../../../utils/AllocationUtils";
import PageHeader from "../../../components/UI/Headers/PageHeader/PageHeader";
import CustomMenu from "../../../components/UI/Menus/CustomMenu/CustomMenu";
import Icons from "../../../resources/icons/Icons";
import Strings from "../../../resources/Strings";
import {
  handleTokenActivation,
  handleDeleteToken,
  handleFobActivation,
  handleRemoveParkerAllocation,
  handleResetFob,
  handleSkipFob
} from "../../../utils/MenuUtils";
import { MenuItemEntity } from "../../../entities/UIEntities/MenuItem";
import { MENU_ITEMS } from "../../../enums/Enums";
import classes from "./ParkerInfo.module.css";
import store from "../../../redux/Store";
import { commonActions } from "../../../redux/reducers/CommonReducer";
import { 
  showErrorMessage, 
  showUpdateSuccessMessage, 
  showMissingFobValueErrorMessage, 
  showReachedTokensAssignLimitErrorMessage 
} from "../../../utils/MessagesUtils";
import * as actionsService from "../../../services/ActionsService/ActionsService";
import * as carUserTokenActionsService from "../../../services/ActionsService/CarUserTokenActionsService";
import { UpdateCarUserTokenEntity } from "../../../entities/ServicesEntities/UserEntities/UpdateCarUserTokenEntity";
import { UpdateCarUserTokenActivationEntity } from "../../../entities/ServicesEntities/UserEntities/UpdateCarUserTokenActivationEntity";
import { CreateCarUserTokenEntity } from "../../../entities/ServicesEntities/UserEntities/CreateCarUserTokenEntity";
import { CarUserTokenOperationsEntity } from "../../../entities/ServicesEntities/UserEntities/CarUserTokenOperationsEntity";
import { userActions } from "../../../redux/reducers/UserReducer";
import { allocationsActions } from "../../../redux/reducers/AllocationsReducer";
import AddParkerToAllocationInfoStep from "../../../components/UI/Forms/Wizard Forms/Steps/AddParkerToAllocationInfoStep";
import { LENGTHS } from "../../../config/Config";
import { refreshAllUsersData } from "../../../services/ParkerService";


const AllocationInfo = (props) => {
  // default allocation received on props is the one selected from table
  // if there is commonTokens (and more than one allocation on window)
  // while clicking on edit, selects the allocation data for the server call to indicate which allocation to update
  const [selectedAllocation, setSelectedAllocation] = useState(props); 
  const [selectedParker, setSelectedParker] = useState(null);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const [showFobScannerInput, setShowFobScannerInput] = useState(false);
  const [showParkersList, setShowParkersList] = useState(false);
  const [fob, setFob] = useState("");

  let allocations = useSelector((state) => state.allocations.allocations);
  let commonAllocations = useSelector((state) => state.allocations.commonTokens); // unfiltered commonTokens from reducer
  let [commonTokens, setCommonTokens] = useState([]); // represents the commonTokens on ui
  
  // check if is disable needed for the token title
  let isDisableNeeded = commonTokens?.length > 0 ? commonTokens.every(token => !token.isActive) : !props?.isActive;   
  let isSingleAllocation = commonTokens?.length === 0; 

  // manages the scan fob inputs list for the allocation cards
  const [showFobInputsByAllocations, setShowFobInputsByAllocations] = useState(commonTokens?.length > 0 ? commonTokens.map(token => [{'id': token.id, 'isShowNeeded': false}]).flat() : []);    
  
  // on every allocation selection change
  useEffect(() => {
    // represents the common carUserTokens founded
    let commonTokens = commonAllocations?.map((cutArr) => {
      if (
        cutArr.some(
          (cut) =>
          cut.userId === props?.parker?.utronUser?.id &&
          cut.tokenId === props?.tokenId
          )
          ) {
            return cutArr;
          }
        })
        .filter((t) => t) // removes undefined
        .flat(); // extracts to array
       
    if (commonTokens?.length > 0) {
      // handle show fob inputs 
      setShowFobInputsByAllocations(commonTokens.map(token => [{'id': token.id, 'isShowNeeded': false}]).flat());
      
      // if commonTokens founded on the selected allocation:
      // order commonTokens by parker name 
      let first = commonTokens.find(token => token.userId === props.parker.utronUser.id);
      commonTokens = commonTokens.filter(token => token.userId !== first.userId);
      commonTokens.unshift(first);
    }

    setCommonTokens(commonTokens);

    // clear fob input & fob display 
    // & set the table allocation as the inner selection as default
    setFob("");
    setShowFobScannerInput(false);

    let propsCopy = {...props};

    // case created single allocation and window still opened from last session
    // updates allocation data for making actions
    if (typeof props.id === 'string' && commonTokens?.length === 0) {
      let foundedAllocation = allocations.find(allocation => allocation.tokenId === props.tokenId);

      if (foundedAllocation) {
        propsCopy = {...foundedAllocation};
        store.dispatch(allocationsActions.setAllocationSelectionModel(propsCopy));
      }
    }

    setSelectedAllocation(propsCopy);
    handleCloseAddParkerInputs();

    // on unmount clean showFobInputsByAllocations list
    return () => {
      setShowFobInputsByAllocations([]);
    };

  }, [props]);

  const isActivateTokenMenuItem = () => {
    // commmon
    if (commonTokens?.length > 0 && commonTokens.every(token => !token.isActive)) {
      return false;
    }
    if (commonTokens?.length > 0 && !commonTokens.every(token => !token.isActive)) {
      return true;
    }
    // single
    if (selectedAllocation?.isActive) {
      return true;
    }
    else {
      return false;
    }
  };

  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.ADD_PARKER,
      commonTokens?.length >= LENGTHS.MAX_ASSIGNED_NUMBER_PER_TOKEN_LENGTH ? () => showReachedTokensAssignLimitErrorMessage() : () => openAddParker(),
      true,
      Icons.MY_PROFILE,
      false,
      props,
      commonTokens?.length >= LENGTHS.MAX_ASSIGNED_NUMBER_PER_TOKEN_LENGTH || showParkersList
    ),
    new MenuItemEntity(
      isActivateTokenMenuItem() ? MENU_ITEMS.DEACTIVATE_TOKEN : MENU_ITEMS.ACTIVATE_TOKEN, 
      () => openTokenActivationModal(), 
      true,
      isActivateTokenMenuItem() ?  Icons.DISACTIVATE_TOKEN : Icons.TOKEN_ITEM, 
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      () => openDeleteTokenModal(), 
      true,
      Icons.DELETE_ITEM,
      false,
      props
    ),
  ];

  const handleClose = () => {
    props.handleCloseEvent();
  };

  const addParkerToAllocation = (selectedParker, skipFob = false) => {
        // if fob ok add the selectedParker & allocation data to commonTokens
        // for the ui - if single - get the single parker and add the added parker together
        let carUserTokenData = {fob: !props.token.site.isFobsSupported ? null : fob, isActive: true, isOccupied: false, carId: null};
        let selectedParkerToAddAllocation = null; 

        if (isSingleAllocation) {
          // check if already exists
          selectedParkerToAddAllocation = getAddedParkerToAllocationModel(selectedParker, props, carUserTokenData);

          // move the single current parker to the commonTokens list to render multiple allocations on ui
          // setCommonTokens([{...props}, {...selectedParkerToAddAllocation}]);

          // if (showFobInputsByAllocations?.length === 0) {
          //   // set both for current parker, and added parker to allocation
          //   setShowFobInputsByAllocations([{'id': props.id, 'isShowNeeded': false}, {'id': selectedParkerToAddAllocation.id, 'isShowNeeded': false}]);
          // }
        }
        else {
          selectedParkerToAddAllocation = getAddedParkerToAllocationModel(selectedParker, commonTokens[0], carUserTokenData);
          
          // setCommonTokens([...commonTokens, {...selectedParkerToAddAllocation}]);
          // setShowFobInputsByAllocations([...showFobInputsByAllocations, {'id': selectedParkerToAddAllocation.id, 'isShowNeeded': false}]);
        }

        // handle circular - cut props.site.tokens
        // token without sitesTokens
        let site = {...selectedParkerToAddAllocation.token.site}; 
        let token =  {...selectedParkerToAddAllocation.token};

        site.tokens = []; // clear tokens from site
        site.userSites = []; // clear userSites from site
        token.site = site;        

        let carUserToken = new CreateCarUserTokenEntity(
          0,
          selectedParkerToAddAllocation.carId,
          selectedParkerToAddAllocation.userId,
          selectedParkerToAddAllocation.tokenId,
          !props.token.site.isFobsSupported || skipFob ? null : fob,
          selectedParkerToAddAllocation.isOccupied,
          selectedParkerToAddAllocation.isActive,
          null,
          token
        );

        const carUserTokenOperationsEntity = new CarUserTokenOperationsEntity(
          selectedParkerToAddAllocation.userId,
          token.siteId,
          selectedParkerToAddAllocation.token.userTypeId,
          [carUserToken]
        );        
        
        carUserTokenActionsService
      .assignCommonCarUserTokens(carUserTokenOperationsEntity, true, false)
      .then((response) => {
        if (response.data.isSuccess && response.data.entity?.[0]) {
          actionsService.getUserSites(true, false)
            .then((sitesResponse) => {
              store.dispatch(userActions.setSites(sitesResponse.data.entity));
              store.dispatch(userActions.setUsersScope(selectedScope.id));
              
              refreshAllUsersData(null, null, true, true).then(() => {
                  const state = store.getState();
                  store.dispatch(allocationsActions.setAllocations({
                    parkers: state.user.parkers,
                    sites: state.user.sites,
                    userTypes: state.user?.initialState?.userTypes
                  }));
                  showUpdateSuccessMessage();
                  }).catch((error) => {
                  console.error('Error refreshing user extended data:', error);
                });
            });          
        } else {
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      })
      .catch(error => {
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      });

    handleCloseAddParkerInputs();
  };

  // Handle select parker list input
  const handleSelectChange = (selectedParker) => {
    setSelectedParker(selectedParker['selectedParker']);

    // if fob is not supported on site, do the add parker 
    if (!props.token.site.isFobsSupported) {
      addParkerToAllocation(selectedParker['selectedParker']); // local selectedParker
    }
  };

  const handleCloseAddParkerInputs = () => {
    setSelectedParker(null);
    setShowParkersList(false);
    setFob("");
  };

  // Handle Fob Input
  const handleCloseFobInput = (selectedAllocationId) => {
    if (showFobInputsByAllocations?.length > 0) {
      let showFobInputsByAllocationsCopy = [...showFobInputsByAllocations];
      let foundedAllocationIndex = showFobInputsByAllocations.findIndex(allocation => allocation.id === selectedAllocationId);
      showFobInputsByAllocationsCopy[foundedAllocationIndex].isShowNeeded = false;

      setShowFobInputsByAllocations(showFobInputsByAllocationsCopy);
    }
    
    setShowFobScannerInput(false);
    setFob("");
  };

  const openAddParker = () => {
    // close edit fob when add parker is clicked
    // on common allocations case
    if (showFobInputsByAllocations?.length > 0) {
      let showFobInputsByAllocationsCopy = [...showFobInputsByAllocations];
      
      // close existing scan fob input (if any) before opening parkers search list
      if (showFobInputsByAllocations.some(allocation => allocation.isShowNeeded)) {
        let foundedAllocationIndex = showFobInputsByAllocations.findIndex(allocation => allocation.isShowNeeded);
        showFobInputsByAllocationsCopy[foundedAllocationIndex].isShowNeeded = false;
      }
    }
    else {
      // on single allocation case
      setShowFobScannerInput(false);
    }
    
    // open parkers search list
    setShowParkersList(true);
  };

  const handleConfirmAddParkerScanFob = () => {
    if (fob === '' || fob === null || fob === undefined) {
      showMissingFobValueErrorMessage();
      return;
    }

    actionsService.isFobOk(fob, true, false).then(response => {
      if (response.data.isSuccess) {
        addParkerToAllocation(selectedParker); // state selectedParker

        // close fob input & list
        setFob("");
      }
      else {
        // error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    }).catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    });
  };

  const handleChange = (event) => {
    setFob(Object.values(event)[0]);
  };

  // indicates which allocation the user selected from side-window allocation list (occurs on edit)
  const targetAllocation = (selectedAllocationId) => {
    // if selected allocation is different from selected allocation on table
    // change to the inner selected allocation (will happen when theres commonTokens, on single token - won't change)
    if (selectedAllocation.id !== selectedAllocationId) {
      let foundedAllocation = commonTokens?.find(token => token.id === selectedAllocationId);

      // set only if founded
      if (foundedAllocation) {
        setSelectedAllocation(foundedAllocation);
        setFob("");
      }
    }

    // on common allocations case
    if (showFobInputsByAllocations?.length > 0) {
      let showFobInputsByAllocationsCopy = [...showFobInputsByAllocations];

      // close existing fob scan input (if any) before open the selected
      if (showFobInputsByAllocations.some(allocation => allocation.isShowNeeded)) {
        let foundedAllocationIndex = showFobInputsByAllocations.findIndex(allocation => allocation.isShowNeeded);
        showFobInputsByAllocationsCopy[foundedAllocationIndex].isShowNeeded = false;
      }

      // open selected
      let foundedAllocationIndex = showFobInputsByAllocations.findIndex(allocation => allocation.id === selectedAllocationId);
      showFobInputsByAllocationsCopy[foundedAllocationIndex].isShowNeeded = true;

      setShowFobInputsByAllocations(showFobInputsByAllocationsCopy);
    }
    else {
      // on single allocation case
      setShowFobScannerInput(true);
    }

    // close parkers search when edit fob is clicked
    if (showParkersList) {
      handleCloseAddParkerInputs();
    }   
  };

  const openTokenActivationModal = () => {
    let isActiveTokenObj = { isActive : isActivateTokenMenuItem()};

    // pass to the modal the relevant allocation and the action func to make
    handleTokenActivation(isActiveTokenObj, () => tokenActivation());
  };

  const tokenActivation = () => {
    // activate / disactivate by tokenId
    let updateCarUserTokenActivationEntity = new UpdateCarUserTokenActivationEntity(selectedAllocation.tokenId, !isActivateTokenMenuItem());

    carUserTokenActionsService.updateCarUserTokensActivation(updateCarUserTokenActivationEntity, true, false)
    .then(response => {
      if (response.data.isSuccess) {

        if (props?.isAddAllocationProcess) {
          props?.updateActivationAssignedParkerAllocationsByTokenId(selectedAllocation.tokenId);
        }

        showUpdateSuccessMessage();
        // update all allocations by triggering the currentUsersScopes on useAllocationService
        store.dispatch(userActions.setUsersScope(selectedScope.id));
      }
      else {
        //error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }

    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    });

    handleCloseAddParkerInputs();
  };

  const openDeleteTokenModal = () => {
    // pass to the modal the relevant allocation and the action func to make
    handleDeleteToken(() => deleteToken());
  };

  const deleteToken = () => {
    carUserTokenActionsService.deleteCarUserTokensByTokenId(selectedAllocation.tokenId)
     .then(response => {
      if (response.data.isSuccess) {
        store.dispatch(allocationsActions.setAllocationSelectionModel(null));
        
        // delete assigned allocations list if opened from parking allocation
        if (props?.isAddAllocationProcess) {
          props?.deleteAssignedParkerAllocationsByTokenId(selectedAllocation.tokenId);

          // auto return to step 1 - in both cases common and single
          props?.handleStateDataChange({
            ["currentStep"]: 1
          });
        }

        showUpdateSuccessMessage();
        // update all allocations by triggering the currentUsersScopes on useAllocationService
        store.dispatch(userActions.setUsersScope(selectedScope.id));
      }
      else {
        //error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
      
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    });

    handleCloseAddParkerInputs();
  };

  const openFobActivationModal = (selectedAllocationId) => {
    // set the outer selection as default
    let foundedAllocation = selectedAllocation;

    // if the outer selection is different than the inner selection change the targeted allocation
    if (selectedAllocation.id !== selectedAllocationId) {
      foundedAllocation = commonTokens?.find(token => token.id === selectedAllocationId);
    } 

    // pass to the modal the relevant allocation and the fob action func to make
    handleFobActivation(foundedAllocation, () => fobActivation(selectedAllocationId));
  };

  const fobActivation = (selectedAllocationId) => {
    // set the outer selection as default
    let foundedAllocation = selectedAllocation;

    // if the outer selection is different than the inner selection change the targeted allocation
    if (selectedAllocation.id !== selectedAllocationId) {
      // set only if founded
      if (commonTokens?.some(token => token.id === selectedAllocationId)) {
        foundedAllocation = commonTokens?.find(token => token.id === selectedAllocationId);
      }
    } 

    // handle circular - cut props.site.tokens
    // token without sitesTokens
    let site = {...foundedAllocation.token.site}; 
    let token =  {...foundedAllocation.token};

    site.tokens = []; // clear tokens from site
    site.userSites = []; // clear userSites from site
    token.site = site; 

    let carUserToken = new CreateCarUserTokenEntity(
      foundedAllocation.id,
      foundedAllocation.carId,
      foundedAllocation.userId,
      foundedAllocation.tokenId,
      foundedAllocation.fob,
      foundedAllocation.isOccupied,
      !foundedAllocation.isActive,
      foundedAllocation.car,
      token 
    );

    const updateCarUserTokenEntity = new UpdateCarUserTokenEntity(
      foundedAllocation.parker.utronUser.id,
      foundedAllocation.carId,
      [carUserToken] 
    );

    carUserTokenActionsService.updateCarUserToken(updateCarUserTokenEntity).then(response => {
      if (response.data.isSuccess) {

        // update assigned allocations list if opened from parking allocation
        if (props?.isAddAllocationProcess) {
          // pass the updated allocation to be replaced on the parking allocation ui list
          let updatedAllocation = response.data.entity.find(allocation => allocation.id === foundedAllocation.id);
          props?.updateActivationParkerAllocation(updatedAllocation);
        }

        showUpdateSuccessMessage();
        // update all allocations by triggering the currentUsersScopes on useAllocationService
        store.dispatch(userActions.setUsersScope(selectedScope.id));
      }
      else {
        // error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    });
  };

  const handleConfirmScanFob = () => {
    if (fob.trim() === '' || fob === null || fob === undefined) {
      showMissingFobValueErrorMessage();
      return;
    }

    actionsService.isFobOk(fob, true, false).then(response => {
      if (response.data.isSuccess) {
          // do a server fob edit
          // handle circular - cut props.site.tokens
          // token without sitesTokens
          let site = {...selectedAllocation.token.site}; 
          let token =  {...selectedAllocation.token};

          site.tokens = []; // clear tokens from site
          site.userSites = []; // clear userSites from site
          token.site = site; 

          // if isFobOk response is positive - edit fob value
          let carUserToken = new CreateCarUserTokenEntity(
            selectedAllocation.id,
            selectedAllocation.carId,
            selectedAllocation.userId,
            selectedAllocation.tokenId,
            fob,
            selectedAllocation.isOccupied,
            selectedAllocation.isActive,
            selectedAllocation.car,
            token 
          );

          const updateCarUserTokenEntity = new UpdateCarUserTokenEntity(
            selectedAllocation.parker.utronUser.id,
            selectedAllocation.carId,
            [carUserToken] 
          );
            // do the update call
          carUserTokenActionsService.updateCarUserToken(updateCarUserTokenEntity).then(response => {
            if (response.data.isSuccess) {
            // the response here is array of all the most updated carUserTokens of the user's selected allocation
            // update assigned allocations list if opened from parking allocation
            if (props?.isAddAllocationProcess) {
              // pass the updated allocation to be replaced on the parking allocation ui list
              let updatedAllocation = response.data.entity.find(allocation => allocation.id === selectedAllocation.id);
              props?.updateAssignedParkerAllocation(updatedAllocation);
            }

            setFob("");
            handleCloseFobInput(selectedAllocation.id);
            showUpdateSuccessMessage();

            // update all allocations by triggering the currentUsersScopes on useAllocationService
            store.dispatch(userActions.setUsersScope(selectedScope.id));
          }
          else {
            setFob("");
            handleCloseFobInput(selectedAllocation.id);

            // error
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })
        .catch((error) => {          
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        })       
      }
      else {
        // handle to show error with fob value
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    })
  };

  const openResetFobModal = () => {
    // pass to the modal the reset fob action func to make on confirm
    handleResetFob(() => resetFob());
  };

  const resetFob = () => {
      // do a server fob edit - set fob to null
      // handle circular - cut props.site.tokens
      // token without sitesTokens
      let site = {...selectedAllocation.token.site}; 
      let token =  {...selectedAllocation.token};

      site.tokens = []; // clear tokens from site
      site.userSites = []; // clear userSites from site
      token.site = site; 

      // if isFobOk response is positive - edit fob value
      let carUserToken = new CreateCarUserTokenEntity(
        selectedAllocation.id,
        selectedAllocation.carId,
        selectedAllocation.userId,
        selectedAllocation.tokenId,
        null, // set fob to null
        selectedAllocation.isOccupied,
        selectedAllocation.isActive,
        selectedAllocation.car,
        token 
      );

      const updateCarUserTokenEntity = new UpdateCarUserTokenEntity(
        selectedAllocation.parker.utronUser.id,
        selectedAllocation.carId,
        [carUserToken] 
      );
        // do the update call
      carUserTokenActionsService.updateCarUserToken(updateCarUserTokenEntity, true, false).then(response => {
        if (response.data.isSuccess) {
        // the response here is array of all the most updated carUserTokens of the user's selected allocation
        // update assigned allocations list if opened from parking allocation
        if (props?.isAddAllocationProcess) {
          // pass the updated allocation to be replaced on the parking allocation ui list
          let updatedAllocation = response.data.entity.find(allocation => allocation.id === selectedAllocation.id);
          props?.updateAssignedParkerAllocation(updatedAllocation);
        }

        setFob("");
        handleCloseFobInput(selectedAllocation.id);
        showUpdateSuccessMessage();

        // update all allocations by triggering the currentUsersScopes on useAllocationService
        store.dispatch(userActions.setUsersScope(selectedScope.id));
      }
      else {
        setFob("");
        handleCloseFobInput(selectedAllocation.id);

        // error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    })       
  };

  const openSkipFobModal = () => {
    handleSkipFob(() => skipFob());
  };

  const skipFob = () => {
    addParkerToAllocation(selectedParker, true);
  };

  const openRemoveParkerAllocationModal = (selectedAllocationId) => {
    handleRemoveParkerAllocation(() => removeParkerAllocation(selectedAllocationId));
  };

  // handleRemoveParkerAllocation
  const removeParkerAllocation = (selectedAllocationId) => {
    // set the outer selection as default
    let foundedAllocation = selectedAllocation;

    // if the outer selection is different than the inner selection change the targeted allocation
    if (selectedAllocation.id !== selectedAllocationId) {
      if (commonTokens?.some(token => token.id === selectedAllocationId)) {
        foundedAllocation = commonTokens?.find(token => token.id === selectedAllocationId);
      }
    } 
    
    // handle circular - cut props.site.tokens
    // token without sitesTokens
    let site = {...foundedAllocation.token.site}; 
    let token =  {...foundedAllocation.token};

    site.tokens = []; // clear tokens from site
    site.userSites = []; // clear userSites from site
    token.site = site; 

    let carUserToken = new CreateCarUserTokenEntity(
      foundedAllocation.id,
      foundedAllocation.carId,
      foundedAllocation.userId,
      foundedAllocation.tokenId,
      foundedAllocation.fob,
      foundedAllocation.isOccupied,
      foundedAllocation.isActive,
      foundedAllocation.car,
      token 
    );

    // if single, and no common tokens do the delete token call
    let action = null;
    if (isSingleAllocation) {
      action = carUserTokenActionsService.deleteCarUserTokensByTokenId(foundedAllocation.tokenId);
    }
    else {
      action = carUserTokenActionsService.removeCarUserToken(carUserToken);
    }

    action?.then((response) => {
      if (response.data.isSuccess) {
        // indicate to return if the deleted token is associated to the same user opened on initial
        let isReturnNeeded = !commonTokens?.filter(ct => ct.id !== foundedAllocation.id)?.some(t => t.userId === props?.parker?.utronUser?.id);
        
        if (isSingleAllocation || isReturnNeeded) {
          store.dispatch(allocationsActions.setAllocationSelectionModel(null));
        }
        
        // update to delete assigned allocations list if opened from parking allocation
        if (props?.isAddAllocationProcess) {
          // pass the deleted allocation id to be deleted on parking allocation ui list
          props?.deleteAssignedParkerAllocation(foundedAllocation.id);

          // if after delete it is a single allocation or if deleted the same firstly opened user's token, auto return to step 1
          if (isSingleAllocation || isReturnNeeded) {
              props?.handleStateDataChange({
                ["currentStep"]: 1
              });
          }
        }

        showUpdateSuccessMessage();
        // update all allocations by triggering the currentUsersScopes on useAllocationService
        store.dispatch(userActions.setUsersScope(selectedScope.id));
      }
      else {
        // error
        showErrorMessage(response.data?.error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    })
    .catch(error => {
      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
    });
  };

  return (
    <div className={props?.isSpaceNeeded ? [classes.allocationInfo, classes.allocationInfoSpace].join(' ') : classes.allocationInfo}>
      {props?.closeButton && 
        (<IconButton
          className={classes.closeButton}
          aria-label="closeIcon"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        )
      }

      <div className={isDisableNeeded ? [classes.allocationInfoHeader, classes.disable].join(' ') : classes.allocationInfoHeader}>
        <PageHeader
          icon={Icons.ALLOCATIONS2}
          isDisableNeeded={isDisableNeeded} // commonTokens?.length > 0 ? commonTokens.every(token => !token.isActive) : !props?.isActive
          pageTitle={props?.token?.displayValue}
          subTitle={props?.token?.value}
          buttonText={Strings.ADD_NEW_PARKER}
          // validRole={gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR}
          // handleModalOpen={handleModalOpen}
        />
        {props.validRole && <CustomMenu menuItems={menuItems} keepOpen={showParkersList}></CustomMenu>}
      </div>

      <div className={classes.allocationListContainer}>
        {commonTokens?.length > 0 ? (
          commonTokens.map((token, index) => {
            return (
              <AllocationCard
                key={index}
                tokenId={token.id}
                name={`${token.parker?.utronUser.firstName} ${token.parker?.utronUser.lastName}`}
                fob={token.fob}
                isActive={token.isActive}
                image={token.parker.utronUser.image}
                site={props.token.site}
                openFobActivationModal={openFobActivationModal}
                targetAllocation={targetAllocation}
                openRemoveParkerAllocationModal={openRemoveParkerAllocationModal}
                showMenuItems={props.validRole} 
                
                showFobScannerInput={showFobInputsByAllocations.some(allocation => token.id === allocation.id && allocation.isShowNeeded)}
                fobInputValue={fob}
                handleChange={handleChange}
                handleCloseFobInput={handleCloseFobInput}
                handleConfirmScanFob={handleConfirmScanFob}
                handleResetFob={openResetFobModal}
              ></AllocationCard>
            );
          })
        ) : (
          <AllocationCard
            tokenId={props.id}
            name={`${props.parker?.utronUser.firstName} ${props.parker?.utronUser.lastName}`}
            fob={props.fob}
            isActive={props.isActive}
            image={props.parker?.utronUser.image}
            site={props.token?.site}
            openFobActivationModal={openFobActivationModal}
            targetAllocation={targetAllocation}
            openRemoveParkerAllocationModal={openRemoveParkerAllocationModal}
            showMenuItems={props.validRole} 
            
            showFobScannerInput={showFobScannerInput}
            fobInputValue={fob}
            handleChange={handleChange}
            handleCloseFobInput={handleCloseFobInput}
            handleConfirmScanFob={handleConfirmScanFob}
            handleResetFob={openResetFobModal}
          ></AllocationCard>
        )}
      </div>
      {showParkersList && 
      <div className={selectedParker === null ? [classes.parkerToAllocationListContainer, classes.searchParkersList].join(' ') : classes.parkerToAllocationListContainer}>
        <AddParkerToAllocationInfoStep
          tokenId={props.token?.id} // props.id
          site={props.token?.site} 
          userTypeId={props.token?.userTypeId}
          assignedParkers={commonTokens?.length > 0 ? commonTokens.map(ct => ct.parker) : [props?.parker]}
          handleSelectChange={handleSelectChange}
          selectedParker={selectedParker}

          // allocation data
          fob={fob}
          isActive={true}

          // fob actions
          //showFobScannerInput={showFobScannerInput}
          handleCloseAddParkerInputs={handleCloseAddParkerInputs}
          handleSkip={openSkipFobModal}
          handleCloseFobInput={handleCloseFobInput}
          handleChange={handleChange}
          handleConfirmAddParkerScanFob={handleConfirmAddParkerScanFob}

        />
      </div>}
    </div>
  );
};

export default AllocationInfo;
